import { createTheme } from "@mantine/core";

export const theme = createTheme({
  fontFamily: "var(--yc-font-ui)",
  fontFamilyMonospace: "var(--yc-font-mono)",
  headings: {
    fontFamily: "var(--yc-font-ui)",
    fontWeight: "600",
  },
  primaryColor: "ycBlue",
  primaryShade: { light: 6, dark: 6 },
  defaultRadius: "md",
  cursorType: "pointer",
  colors: {
    ycBlue: [
      "#e8f2ff",
      "#d3e6ff",
      "#a8ccff",
      "#79b0ff",
      "#4f96ff",
      "#2f83ff",
      "#0066cc",
      "#005bb5",
      "#004f9e",
      "#004287",
    ],
  },
  components: {
    Button: {
      defaultProps: { radius: "md" },
      styles: { root: { fontWeight: 500 } },
    },
    TextInput: { defaultProps: { radius: "md" } },
    Textarea: { defaultProps: { radius: "md" } },
    PasswordInput: { defaultProps: { radius: "md" } },
    Select: { defaultProps: { radius: "md" } },
    NumberInput: { defaultProps: { radius: "md" } },
    Card: { defaultProps: { radius: "lg" } },
    Modal: { defaultProps: { radius: "xl", centered: true } },
    Paper: { defaultProps: { radius: "lg" } },
    Badge: { defaultProps: { radius: "full" } },
    SegmentedControl: { defaultProps: { radius: "md" } },
    Tabs: { defaultProps: { radius: "md" } },
  },
});
